// Unsaved changes alert modal component
// Props:
// LangData
// AlertMessage (optional, and if not available, default alert message will be displayed)
// **NOTE**: if {props.AlertMessage} is not available, {props.CancelText, props.SaveText} will be ignored
// CancelText (optional, and if not available, default cancel text will be displayed)
// SaveText (optional, and if not available, default save text will be displayed)
// props.close() calls a function in the parent which will close the modal only
// props.save(), props.saveAndLeave() will call save functions in the parent.
// props.discardAndLeave() will close the modal, will NOT call the save function and will leave the page/tab

import React from "react";
import "../../../../../Assets/Styles/UnsavedChanges.scss";

const UnsavedChangesAlert = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <React.Fragment>
      {props.AlertMessage ? (
        <React.Fragment>
          <div
            className={
              window.localStorage.getItem("MenuIsOpen") === "1"
                ? "alert-overlay"
                : "alert-overlay alert-overlay-big"
            }
          >
            <div className="outline" onClick={() => props.close()}></div>
            <div className="alert-body">
              <section className="alert-head">
                <h1>
                  {props.ModalTitle ? (
                    <>{props.ModalTitle}</>
                  ) : (
                    <>
                      {props.LangData
                        ? translateText("unsaved_changes")
                        : "Unsaved Changes"}
                    </>
                  )}
                </h1>
                <button className="iconed" onClick={() => props.close()}>
                  <i className="feather-x"></i>
                </button>
              </section>
              <p>{props.AlertMessage}</p>
              <div
                className={
                  props.ReverseBTNs
                    ? "unsaved-changes-footer reversed-flex"
                    : "unsaved-changes-footer"
                }
              >
                <button
                  className="save-leave-btn"
                  onClick={() => props.close()}
                >
                  {props.CancelText}
                </button>
                <button
                  className="discard-leave-btn"
                  onClick={() => props.save()}
                >
                  {props.SaveText}
                </button>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div
            className={
              window.localStorage.getItem("MenuIsOpen") === "1"
                ? "alert-overlay"
                : "alert-overlay alert-overlay-big"
            }
          >
            <div className="outline" onClick={() => props.close()}></div>
            <div className="alert-body">
              <section className="alert-head">
                <h1>
                  {props.ModalTitle ? (
                    <>{props.ModalTitle}</>
                  ) : (
                    <>
                      {props.LangData
                        ? translateText("unsaved_changes")
                        : "Unsaved Changes"}
                    </>
                  )}
                </h1>
                <button className="iconed" onClick={() => props.close()}>
                  <i className="feather-x"></i>
                </button>
              </section>
              <p>
                {props.LangData
                  ? translateText("unsaved_changes_modal_text")
                  : "You have unsaved changes, If you leave the page your changes will be discarded."}
              </p>
              <div className="unsaved-changes-footer">
                <button
                  className="save-leave-btn"
                  onClick={() => props.saveAndLeave()}
                >
                  {props.LangData
                    ? translateText("save_and_leave")
                    : "Save and leave"}
                </button>
                <button
                  className="discard-leave-btn"
                  onClick={() => props.discardAndLeave()}
                >
                  {props.LangData
                    ? translateText("discard_and_leave")
                    : "Discard and leave"}
                </button>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default UnsavedChangesAlert;
